/**
 * Angular imports.
 */
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Module imports.
 */
import { ProductLikeModule } from './../../../../common/product-like/product-like.module';
import { ProductSubscribeModule } from './../../../../common/product-subscribe/product-subscribe.module';
import { UserProfilePicModule } from './../../../../common/user-pofile-pic/user-profile-pic.module';
import { NgbDropDownModule } from './../../../../common/ngb-drop-down/ngb-drop-down.module';
import { ProductMaskingCardModule } from 'src/app/common/product-masking-card/product-masking-card.module';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { ProductCommentModule } from './../../../../common/product-comment/product-comment.module';
import { ProductCommentBoxModule } from './../../../../common/product-comment-box/product-comment-box.module';
import { WalkthroughModule } from '../../../../walkthrough/walkthrough.module';
import { PipesModule } from '../../../../pipes/pipes.module';

/**
 * Component imports.
 */
import { WebDoctalkCardComponent } from './web-doctalk-card.component';
import { AnalyticsEventModule } from './../../../../analytics-event/analytics-event.module';



@NgModule({
  declarations: [
    WebDoctalkCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    ProductMaskingCardModule,
    NgbDropDownModule,
    UserProfilePicModule,
    ProductSubscribeModule,
    ProductLikeModule,
    AnalyticsEventModule,
    ProductCommentModule,
    ProductCommentBoxModule,
    WalkthroughModule,
    PipesModule
  ],
  exports: [
    WebDoctalkCardComponent
  ]
})
export class WebDoctalkCardModule { }
